import { c as _c } from "react/compiler-runtime";
import { Home } from '@systemeio/digital-store-shared';
import AddItemModal from 'modules/stores/store/components/add-item-modal';
import ProfileContent from 'modules/stores/store/content/profile/profile-content';
import { useStorePreviewContext } from 'modules/stores/store/context/store-preview-context';
import { useStore } from 'modules/stores/store/hooks/use-store';
import { useStoreItemActions } from 'modules/stores/store/hooks/use-store-item-actions';
import { useStoreQuery } from 'modules/stores/store/hooks/use-store-query';
import { getItemContentByType } from 'modules/stores/store/utils/get-item-content-by-type';
import { StoreInterface } from 'modules/stores/types/stores-interface';
import React, { FC, Fragment, useEffect } from 'react';
import Sortable from 'shared/components/sortable';
import { reorderData } from 'shared/components/table/sortable-table/reorder-data';
import AddHeader from '../content/header/add-header';
interface ContentProps {
  storeView: StoreInterface;
}
const StoreContent: FC<ContentProps> = t0 => {
  const $ = _c(29);
  const {
    storeView
  } = t0;
  const {
    setPreview,
    setSingleItemMode
  } = useStorePreviewContext();
  let t1;
  if ($[0] !== setPreview || $[1] !== setSingleItemMode || $[2] !== storeView.id || $[3] !== storeView.items || $[4] !== storeView.profile || $[5] !== storeView.socialLinks) {
    t1 = () => {
      setPreview([<Home key={storeView.id} profile={storeView.profile} socialLinks={storeView.socialLinks} items={storeView.items.filter(_temp)} displayAffiliateLink={false} />]);
      setSingleItemMode(false);
    };
    $[0] = setPreview;
    $[1] = setSingleItemMode;
    $[2] = storeView.id;
    $[3] = storeView.items;
    $[4] = storeView.profile;
    $[5] = storeView.socialLinks;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== setPreview || $[8] !== setSingleItemMode || $[9] !== storeView) {
    t2 = [setPreview, setSingleItemMode, storeView];
    $[7] = setPreview;
    $[8] = setSingleItemMode;
    $[9] = storeView;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  useEffect(t1, t2);
  const {
    storeId
  } = useStoreQuery();
  const {
    mutate
  } = useStore(storeId);
  const {
    reorderItem
  } = useStoreItemActions();
  let t3;
  if ($[11] !== mutate || $[12] !== reorderItem) {
    t3 = async (activeId, activeIndex, overIndex) => {
      await mutate(async data => {
        await reorderItem(activeId, overIndex + 1);
        return reorderData({
          data,
          activeIndex,
          overIndex,
          sortableKey: "items"
        });
      }, {
        optimisticData: data_0 => reorderData({
          data: data_0,
          activeIndex,
          overIndex,
          sortableKey: "items"
        }),
        rollbackOnError: true,
        revalidate: false
      });
    };
    $[11] = mutate;
    $[12] = reorderItem;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const onMoveItem = t3;
  let t4;
  if ($[14] !== storeView.profile || $[15] !== storeView.socialLinks) {
    t4 = <ProfileContent profile={storeView.profile} socialMedia={storeView.socialLinks} />;
    $[14] = storeView.profile;
    $[15] = storeView.socialLinks;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== storeView.items) {
    t5 = storeView.items.map(_temp2);
    $[17] = storeView.items;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== storeView.items) {
    t6 = storeView.items.map(_temp3);
    $[19] = storeView.items;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== onMoveItem || $[22] !== t5 || $[23] !== t6) {
    t7 = <Sortable draggable={getItemContentByType} items={t5} onMove={onMoveItem}>{t6}</Sortable>;
    $[21] = onMoveItem;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="flex flex-row justify-center gap-4 max-sm:flex-col-reverse max-sm:gap-2"><AddItemModal /><AddHeader /></div>;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== t4 || $[27] !== t7) {
    t9 = <div className="flex flex-col gap-5">{t4}{t7}{t8}</div>;
    $[26] = t4;
    $[27] = t7;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
};
export default StoreContent;
function _temp(el) {
  return !el.draft;
}
function _temp2(item) {
  return {
    ...item,
    id: item.itemId
  };
}
function _temp3(item_0) {
  return <Fragment key={item_0.itemId}>{getItemContentByType(item_0)}</Fragment>;
}